import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CounterPartysSelectors } from "src/redux/CounterPartys/selectors";
import { TxSelectors } from "src/redux/Tx/selectors";
import { TxActions } from "src/redux/Tx/actions";

import SelectTable from "src/components/common/SelectTable";
import Dropdown from "src/components/common/Dropdown";

import styles from "./styles.module.scss";

export default ({
    multiple = true,
    acceptsPartnerCpties = false,
    acceptsUnregisteredCpties = false,
}) => {
    const dispatch = useDispatch();

    const knownCptys = useSelector(CounterPartysSelectors.SelectAll);
    const selectedCptys = useSelector(TxSelectors.TxInitSelectedCptyIds);
    const cptyError = useSelector(TxSelectors.TxIniCptyError);
    const loanType = useSelector(TxSelectors.TxInitSelectedLoanType);

    const selectableCptys = knownCptys
        .filter((i) => {
            if (i.partner) return acceptsPartnerCpties;

            if (i.unregistered) return acceptsUnregisteredCpties;

            return true;
        })
        .sort((a, b) => a.name.localeCompare(b.name));

    // for multiple selection we show the list of all cpties
    // and grey out unselectable cpties,
    // whereas for single selection we filter them out outright.
    return (
        <div
            className={`${styles.cptyList} ${cptyError ? styles.error : ""}`}
            data-testid="cpty-list"
        >
            <div className={styles.selectWrapper}>
                {multiple ? (
                    <SelectTable
                        title="Known Counterparties"
                        rows={selectableCptys.map((i) => ({
                            ...i,
                            columns: [
                                i.unregistered ? i.name + " (Email)" : i.name,
                            ],
                        }))}
                        checkIsDisabled={(i) =>
                            ((i.unregistered || i.partner) &&
                                loanType === "HOLD") ||
                            (i.unregistered && !acceptsUnregisteredCpties) ||
                            (i.partner && !acceptsPartnerCpties)
                        }
                        styleType="tx"
                        error={cptyError}
                        selected={selectedCptys}
                        handleAllSelect={() =>
                            dispatch(TxActions.SelectAllCptys())
                        }
                        handleRowSelect={(row) =>
                            dispatch(TxActions.SelectOneCpty(row.id))
                        }
                        noResults="No Known Counter Parties"
                    />
                ) : (
                    <Dropdown
                        mainStyle="thick-black"
                        // react-select's value must be one of the option
                        // OBJECTS (matched by identity / getOptionValue),
                        // not a bare id. selectedCptys is an id array
                        // (post-SelectOneAndOnlyCpty normalization), so
                        // look up the matching option here. Falls back
                        // to undefined → renders the placeholder.
                        value={selectableCptys.find(
                            (c) => c.id === selectedCptys[0]
                        )}
                        error={cptyError}
                        options={selectableCptys}
                        getOptionValue={(el) => el.id}
                        getOptionLabel={(el) => el.name}
                        placeholder={"Select a CPTY"}
                        onChange={(cpty) => {
                            dispatch(TxActions.SelectOneAndOnlyCpty(cpty));
                            dispatch(TxActions.ApplyDefaultObjective(cpty.id));
                        }}
                        dataTestId="tx-offer-select-cpty"
                        ariaLabel="Select a CPTY"
                    />
                )}
            </div>
            {cptyError && (
                <div className={styles.errorMessage}>
                    {multiple
                        ? "Choose at least one counterparty"
                        : "Select a counterparty"}
                </div>
            )}
        </div>
    );
};
